const DossierStatus = Object.freeze({
  OFFRE: 'OFF',
  SIGNED: 'SIG',
  EN_COURS: 'ENC',
  A_FACTURER: 'AFA',
  FACTURE: 'FAC',
  PAYE: 'PAY',
  ARCHIVE: 'ARC',
  REPORTE: 'REP',
  SCIENCE: 'SCI',
  CANCELED: 'CANC',
  PROSPECT: 'PROS',
  CONVERTED: 'CON'
})

export default DossierStatus
